export { default as lightLogo } from "./svg/Light-PeopleSync.svg";
export { default as darkLogo } from "./svg/Dark-PeopleSync.svg";